import Gantt from 'frappe-gantt';

import { Schedules } from '../types';

import {
  calculateForGanttForConstructionZone,
  calculateForGanttForTask,
} from './calculateForGantt';

import { Site } from '@/features/saveSite/types';
import { OutputErrorLog } from '@/lib/error';

type ConvertScheduleConstructionZonesToGanttTaskResponse = {
  ganttTasks: Gantt.Task[];
};

const initialReponse = {
  ganttTasks: [],
};

export const convertScheduleConstructionZonesToGanttTask = (input: {
  site?: Site | null;
  schedule?: Schedules | null;
}): ConvertScheduleConstructionZonesToGanttTaskResponse => {
  try {
    const ganttTasks: Gantt.Task[] = [];
    if (!input.schedule) return initialReponse;
    if (!input.site) return initialReponse;
    const { schedule, site } = input;
    //ScheduleとConstructionZoneを紐付ける
    const scheduleDetailConstructionZones = schedule.constructionZones;
    scheduleDetailConstructionZones.forEach((constructionZone, index) => {
      const constructionZoneGantt = calculateForGanttForConstructionZone({
        constructionZone,
      });
      ganttTasks.push(constructionZoneGantt);
      const tasks =
        constructionZone?.tasks?.map((task) => {
          const taskGantt = calculateForGanttForTask({
            task,
            constructionZone,
          });
          return taskGantt;
          //    ganttTasks.push(taskGantt);
        }) || [];

      ganttTasks.push(...tasks);
    });

    return { ganttTasks };
  } catch (e) {
    OutputErrorLog('convertScheduleConstructionZonesToGanttTask', e);
    return initialReponse;
  }
};
